// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sNoU","content":"styles_content__2AV8m"};